import { useState } from 'react';
import { Button } from 'components/Button';
import { Snackbar, SnackbarProps } from 'components/Snackbar';
import { CustomersListItem } from './CustomersListItem';
import { CurrentUser, SimpleCustomer } from 'types';

import cx from 'classnames';
import styles from './CustomersList.module.scss';

export type CustomersListProps = {
  currentUser?: CurrentUser;
  customers: Array<SimpleCustomer>;
  hasMorePages: boolean;
  customWrapper?: boolean;
  onShowMore: () => void;
  useDirectLinks?: boolean;
};

export const CustomersList = ({
  currentUser,
  customers,
  hasMorePages,
  customWrapper,
  onShowMore,
  useDirectLinks,
}: CustomersListProps) => {
  const [snackbarMessage, setSnackbarMessage] = useState<SnackbarProps | null>(null);

  const handleFollowed = (followed: boolean) => {
    setSnackbarMessage({
      header: followed ? 'Followed successfully' : 'Unfollowed successfully',
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbarMessage(null);
  };

  return (
    <div
      className={cx(styles.usersListWrapper, {
        [styles.customWrapper]: customWrapper,
      })}
    >
      <div className={styles.usersList}>
        {customers.map((user: SimpleCustomer) => (
          <CustomersListItem
            key={user.id}
            currentUser={currentUser}
            user={user}
            onFollowed={handleFollowed}
            useDirectLinks={useDirectLinks}
            setSnackbarMessage={setSnackbarMessage}
          />
        ))}
      </div>
      {hasMorePages && (
        <div className={styles.showMoreWrapper}>
          <Button caption="Show More" action={onShowMore} buttonType="white" shape="slimy" />
        </div>
      )}
      {snackbarMessage && <Snackbar {...snackbarMessage} onClose={handleCloseSnackbar} />}
    </div>
  );
};
